import PricingReportRetailerAutocomplete from "./PricingReportRetailerAutocomplete";

function PricingReportRetailerFilter({ options, value, onChange, loading = false }) {
  return (
    <PricingReportRetailerAutocomplete
      options={options}
      value={value}
      onChange={onChange}
      multiple
      showCounts
      loading={loading}
    />
  );
}

export default PricingReportRetailerFilter;
